import React, { Component } from 'react';
import { matchPath } from 'react-router';
// import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import "./css/style.css";

export default class VideoDownloadSent extends Component {
    constructor(props) {
        super(props);
        this.state = props.location.state || {};
    }
    componentDidMount() {
        if (!this.state.Email) {
            let urlParams = matchPath(window.location.pathname, {
                path: '/scan/:id/downloadReady/:recEmail',
                exact: true
            });
            if (urlParams && urlParams.params) {
                this.setState({ Email: urlParams.params.recEmail || "your email address" });
            } else {
                this.setState({ Email: "your email address" });
            }
        }
    }
    render() {
        return (
            <div>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div className="head">
                                <div className="logoImage"></div>
                                <p>Your video is ready for download.</p>
                                <p>
                                    An email has been sent to {this.state.Email} with a link to download your video.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/VideoDownloadSent.js